// ── Objective Level Hierarchy ────────────────────────────────────────────────

export const OBJECTIVE_LEVELS = [
  "department",
  "team",
  "individual",
] as const;
export type ObjectiveLevel = (typeof OBJECTIVE_LEVELS)[number];

/** Numeric rank for level hierarchy validation. Lower = higher level. */
export const LEVEL_RANK: Record<ObjectiveLevel, number> = {
  department: 0,
  team: 1,
  individual: 2,
};

export const LEVEL_LABELS: Record<ObjectiveLevel, string> = {
  department: "Department",
  team: "Team",
  individual: "Individual",
};

export const ORDERED_LEVELS: ObjectiveLevel[] = ["department", "team", "individual"];

// ── Hierarchy ───────────────────────────────────────────────────────────────

/** Maximum hops when walking up the manager_id chain (cycle guard). */
export const MAX_HIERARCHY_HOPS = 20;

// ── Structural Validation ───────────────────────────────────────────────────

/** Minimum number of key results required before an objective can leave draft. */
export const MIN_KRS_PER_OBJECTIVE = 2;

/** Maximum number of key results allowed before an objective can leave draft. */
export const MAX_KRS_PER_OBJECTIVE = 8;
